<template>
  <span>
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn outlined :icon="!activatorLabel" v-on="on">
          <v-icon :size="iconSize">{{activatorIcon ? activatorIcon:'mdi-plus'}}</v-icon>
          {{activatorLabel}}
        </v-btn>
      </template>

      <v-card height="500" width="100%" class="mx-auto">
        <v-card-title>{{title || 'Add Student to Course'}}</v-card-title>
        <v-card-text class="mt-5">
        <v-autocomplete
          v-model="student"
          :items="students"
          :loading="isAppLoading"
          :search-input.sync="search"
          hide-no-data
          hide-selected
          no-filter
          item-text="label"
          item-value="id"
          label="Search for student by name or email"
          placeholder="Start typing to Search"
          prepend-icon="mdi-database-search"
          return-object
        ></v-autocomplete>

          <span>Selected Student: {{this.student ? this.student.label:'N/A'}}</span>
          <v-checkbox v-model="inviteGoogleClassroom" value="true" label="Invite on Google Classroom"/>
          <v-checkbox v-model="addOnGoogleCalendar" value="true" label="Add to guest on Google Calendar"/>
          <span>Only student with email registered could be added to Google classroom and calendar</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="selectedStudent">Select Student</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["activatorIcon", "activatorLabel", "iconSize", "title"],
  data() {
    return {
      dialog: false,
      students: [],
      student: null,
      search: null,
      addOnGoogleCalendar: false,
      inviteGoogleClassroom: false
    };
  },
  watch: {
    search(query) {
      console.log(`query ${query} vs selected ${this.student ? this.student.label:''}`)
      let selected = false;
      if(this.student){
        selected = query == this.student.label;
      }

      if(!selected) {
        // cancel pending call
        clearTimeout(this._timerId)

        // delay new call 500ms
        this._timerId = setTimeout(() => {
          this.queryStudents(query);
        }, 500)
      }

    },
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    queryStudents(term) {
      // cancel pending call
      clearTimeout(this._timerId);

      // delay new call 500ms
      this._timerId = setTimeout(() => {
        this.students = []; //reset customer list
        const data = { searchTerm: term, searchEntities: ["STUDENT"] };
        this.$axios.post("search", data).then(resp => {
          const searchResults = resp.data;
          const students = searchResults.students;
          // console.log('Found Results')
          // console.log(students)
          if (students && students.length > 0) {
            this.students = students.map(s => { return {id: s.id, label: `${s.firstName} ${s.lastName} (${s.email ? s.email:'no email'})`} });
            // console.log(this.students )
          }
        });
      }, 500);
    },
    openDialog(event) {
      this.$emit("onOpen", event);
    },
    selectedStudent() {
      const googleServices = {
        classroom: this.inviteGoogleClassroom,
        calendar: this.addOnGoogleCalendar
      }
      this.$emit("selectedStudent", this.student, googleServices);

      this.dialog = false;
    }
  },
  mounted() {
  }
};
</script>

<style>
</style>